// extracted by mini-css-extract-plugin
module.exports = {"main":"LoginLayout_main__JQPYZ"};